import { QueryClient } from "@tanstack/react-query";
import { ApiFailure } from "@/api/client.ts";
import { authStatusQuery } from "@/features/auth/session.ts";
import type { AuthStatus } from "@codvero/shared";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (count, err) => !(err instanceof ApiFailure && err.status < 500) && count < 2,
      refetchOnWindowFocus: false,
    },
  },
});

/** Any 401 from the API means the session died: drop the cached user so route guards redirect. */
queryClient.getQueryCache().subscribe((e) => {
  if (e.type === "updated" && e.action.type === "error" && e.action.error instanceof ApiFailure && e.action.error.status === 401) {
    queryClient.setQueryData<AuthStatus>(authStatusQuery.queryKey, (old) => ({ setupRequired: false, user: null, googleSignIn: false, singleProject: old?.singleProject ?? false, edition: old?.edition ?? null }));
  }
});
